module.exports = __webpack_public_path__ + "img/logo3.2ce89165.png";